/**
*
* notify
*
******************

This function can be called from any component to show a simple, consistently-styled toast notification.

1. Import the following into the component:

import { ToastContainer } from 'react-toastify'
import { notify } from 'utils/notify'
 
2. Place <ToastContainer /> within your jsx. The location is probably not important. 

3. Use notify within a callback when you want to show the toast. For example,

onCompleted={ () => notify({message: 'Preference updated'}) }

The argument is an object which can contain the following:
message: your message.
options:, an optional object you can use to override default_options below, such as {position: "top-right"}
    Docs:  https://github.com/fkhadra/react-toastify
    Demo:  https://fkhadra.github.io/react-toastify/
styles: an optional object containing styles, such as {textDecoration: 'underline'}.

****************** */

import React from 'react'
import { toast } from 'react-toastify'

const default_options = {
	autoClose: 5000,
	position: 'bottom-left',
	pauseOnHover: true,
	hideProgressBar: true,
	closeButton: false,
}

const default_styles = {
	textAlign: 'center',
}

export function notify({ message, options, styles }) {
	const final_styles = { ...default_styles, ...styles }
	const final_options = { ...default_options, ...options }

	toast.info(<div style={final_styles}>{message}</div>, final_options)
}
